export default "/_next/static/images/738c19f1e7965b177d57fed36296441a.jpg";